import { render, staticRenderFns } from "./Reactivation.vue?vue&type=template&id=2c6819dc&"
import script from "./Reactivation.vue?vue&type=script&lang=ts&"
export * from "./Reactivation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports